// -- Import Actions
import { commonActions } from  '../../actions/commonActions';
import {guaranteeSetItem, guaranteeAddItem,guaranteeGetItem} from '../../actions/guaranteeActions';
import { connect } from 'react-redux';
import AddEditForm from '../../components/guarantee/ApplyGuarantee';
import {API_FETCH} from '../../services/FetchService';
import {alertConstants, commonConstants} from "../../constants";
import {reset} from "redux-form";


const mapStateToProps = state => {
    return {
        common: state.common,
        initialValues: state.guarantee.getItem,
        userValue: state.app.currentUser,
        bankList  : state.financial.bankList,
    }
};


const mapDispatchToProps = dispatch => ({
    onPageLoad: view => {
        dispatch(commonActions.pagePreLoaded(view))
    },
    getItem: (id) => {
        dispatch(getItem(id));
    },

    /* ------------ -------------- ------------*/
    /* ------------ ON SUbmit Form ------------*/
    /* ------------ -------------- ------------*/
    onSubmit: (value)=>{
        dispatch(add(value));
    },

});


/* ------------------------------------------------ */
/* -------- Functions of mapDispatchToProps ------- */
/* ------------------------------------------------ */

const add = (values,mode) => {
    let inquiryId = values._id;

    return (dispatch, getState) => {
        let states = getState()
        var formData = {
            'operator_description': values.operator_description,
            'apply_commuting' : values.apply_commuting[0] ? values.apply_commuting[0] : false,
            'operator_price'  : states.guarantee.getItem.operator_prices,
            'approved_guarantee'  : states.guarantee.getItem.approved_guarantee,
        };

        dispatch({type: commonConstants.FORM_REQUEST});
        API_FETCH.put('guarantee/'+inquiryId, formData).then(res => {
            dispatch(guaranteeAddItem(res.data.lists));
            if(res.status === 200) {
                dispatch({type: commonConstants.FORM_SUCCESS});
                dispatch({
                    type: alertConstants.SUCCESS,
                    message: 'عملیات شما با موفقیت انجام شد'
                })
                dispatch(reset('applyGuarantee'));
                setTimeout(() => dispatch({type: commonConstants.PAGE_REDIERCT, redirectTo: '/guarantee/inquiry'}), 100)
            }else {
                dispatch({type: commonConstants.FORM_FAILURE});
                dispatch({
                    type: alertConstants.ERROR,
                    message: 'خطا در ایجاد'
                })
            }
        }).catch(error => {
            dispatch({type: commonConstants.FORM_FAILURE});
            dispatch({
                type: alertConstants.ERROR,
                message: 'خطای سرور'
            })
        });

    }
}

export const getItem = (inquryId) => {
    return (dispatch, getState) => {
        API_FETCH.get('guarantee/inquiry/'+inquryId).then(guaranteeInfo => {
            dispatch(guaranteeGetItem(guaranteeInfo.data.date));
        }).catch(error => {
            dispatch({type: commonConstants.FORM_FAILURE});
            dispatch({
                type: alertConstants.ERROR,
                message: 'خطای سرور'
            })
        });
    }
}



export default connect(mapStateToProps, mapDispatchToProps)(AddEditForm);
